import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from 'moment'
import { NavigationContext } from '../../context/navigation-context'
import { NotificationManager } from 'react-notifications'
import SearchFilter from '../../components/Filter/SearchFilter'

const FZS = () => {
  const { TRL_Pack } = useContext(LangContext);
  const { fetchMssqlApi } = useFetch();
  const { setHeaderData } = useContext(NavigationContext);

  const [FZS, setFZS] = useState(null);
  const [contractors, setContractors] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const defaultFilter = {
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    name: "fzs",
    page: 1,
    rowsPerPage: 50,
    contractorId: null,
    contractorName: "",
    warehouseId: null,
    warehouseName: "",
    sortBy: "none",
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    WarehouseOperationFullName: "DESC",
    OriginalDocNumber: "ASC",
    ContractorName: "ASC",
    WarehouseFullName: "ASC",
    TotalBrutto: "DESC",
    IsPaid: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);

    getFZS(
      next.dateTimeRangeFrom,
      next.dateTimeRangeTo,
      next.contractorId,
      next.warehouseId,
      null,
      next.sortBy
    );
  };

  useEffect(() => {
    const handleResize = () => {
      const height = window.innerHeight;
      setWindowHeight(height);

      const reservedSpace = 350;
      const visibleRows = Math.floor((height - reservedSpace) / 40);

      setFilter((prev) => ({
        ...prev,
        rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getWarehouses = () => {
    fetchMssqlApi("warehouses-list", {}, (warehouses) =>
      setWarehouses(warehouses)
    );
  };

  const getContractors = () => {
    fetchMssqlApi("contractors-list", {}, (contractors) =>
      setContractors(contractors)
    );
  };

  const getFZS = (
    fromCreateDateTime = filter.dateTimeRangeFrom,
    toCreateDateTime = filter.dateTimeRangeTo,
    contractorId = filter.contractorId,
    warehouseId = filter.warehouseId,
    createUserId = null,
    sortBy = filter.sortBy
  ) => {
    if (
      !moment(fromCreateDateTime).isValid() ||
      !moment(toCreateDateTime).isValid()
    ) {
      NotificationManager.error("Wybierz poprawną datę");
      return;
    }

    const from = moment(fromCreateDateTime).format("YYYY-MM-DD HH:mm:ss");
    const to = moment(toCreateDateTime).format("YYYY-MM-DD HH:mm:ss");

    fetchMssqlApi(
      "fz-fzs",
      {
        method: "POST",
        hideNotification: true,
        data: {
          clientId: sessionStorage.getItem("clientId"),
          fromCreateDateTime: from,
          toCreateDateTime: to,
          contractorId: contractorId || null,
          warehouseId: warehouseId || null,
          createUserId: createUserId,
          sortBy: sortBy || null,
        },
      },
      (response) => {
        setFZS(response);
      }
    );
  };

  useEffect(() => {
    getFZS();
    setHeaderData({
      text: TRL_Pack.fz.fzs,
    });
    getWarehouses();
    getContractors();
  }, []);

  useEffect(() => {
    localStorage.setItem("fzsFilter", JSON.stringify(filter));
  }, [filter]);

  const getUI = () => {
    if (!FZS) return null;

    const filtered = FZS.filter((t) => {
      if (
        filter.warehouseName &&
        !t.WarehouseFullName?.toLowerCase().includes(
          filter.warehouseName.toLowerCase()
        )
      )
        return false;

      if (
        filter.contractorName &&
        !t.ContractorName?.toLowerCase().includes(
          filter.contractorName.toLowerCase()
        )
      )
        return false;

      return true;
    });

    return (
      <div>
        <div className="container-fluid">
          <SearchFilter
            filterName="fzs"
            defaultFilter={defaultFilter}
            onFilterChange={(f) => setFilter((prev) => ({ ...prev, ...f }))}
            onSettingsChange={(s) =>
              setSettingsFilter((prev) => ({ ...prev, ...s }))
            }
            search={() =>
              getFZS(
                filter.dateTimeRangeFrom,
                filter.dateTimeRangeTo,
                filter.contractorId,
                filter.warehouseId,
                null,
                filter.sortBy
              )
            }
            loading={false}
            totalCount={filtered.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
            dataList={FZS}
            forNow
          />

          <div className="card">
            <h5 className="card-header">
              <div className="d-flex justify-content-between">
                <div></div>
                <Link
                  to={`/fz/0`}
                  className="btn text-nowrap btn-outline-secondary"
                >
                  <i className="fas fa-plus" />
                </Link>
              </div>
            </h5>

            <div
              className="overflow-auto custom-scroll"
              style={{
                maxHeight: `${windowHeight - 218}px`,
                overflowY: "auto",
              }}
            >
              {filtered.length ? (
                <table className="table table-striped">
                  <thead>
                    <tr className="text-center headers-color">
                      <th
                        className="align-middle"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("WarehouseOperationFullName")}
                      >
                        Nr faktury {arrow("WarehouseOperationFullName")}
                        <br />
                        Czas zapisu, Źródło
                      </th>
                      <th
                        className="align-middle"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("OriginalDocNumber")}
                      >
                        Nr oryginalny {arrow("OriginalDocNumber")}
                        <br />
                        Wystawiony
                      </th>
                      <th
                        className="align-middle"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("ContractorName")}
                      >
                        Kontrahent{arrow("ContractorName")}
                      </th>
                      <th
                        className="align-middle"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("WarehouseFullName")}
                      >
                        Magazyn{arrow("WarehouseFullName")}
                        <br />
                        PZ
                      </th>
                      <th
                        className="align-middle"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("TotalBrutto")}
                      >
                        Brutto, VAT{arrow("TotalBrutto")}
                        <br />
                        Netto
                      </th>
                      <th
                        className="align-middle"
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("IsPaid")}
                      >
                        Zapłacona{arrow("IsPaid")}
                        <br />
                        Data płatności
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered
                      .slice(
                        (filter.page - 1) * rowsPerPage,
                        filter.page * rowsPerPage
                      )
                      .map((entry, idx) => {
                        const createdDate = entry?.Created
                          ? moment(entry.Created).format("YYYY.MM.DD")
                          : "";
                        const createdTime =
                          entry?.Created?.split(" ").at(-1) || "";

                        const issuedOn = entry?.IssuedOn
                          ? moment(entry.IssuedOn).format("YYYY.MM.DD")
                          : "";

                        const paymentDate =
                          entry?.PaymentDate &&
                          moment(entry.PaymentDate).isValid()
                            ? moment(entry.PaymentDate).format("YYYY.MM.DD")
                            : "";

                        return (
                          <tr key={idx}>
                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <Link
                                  to={`/fz/${entry.WarehouseOperationId}`}
                                  className="btn text-nowrap btn-sm btn-outline-secondary"
                                >
                                  FZ {entry.WarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}
                                </Link>
                                <div>
                                  {createdDate} {createdTime}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="text-nowrap">
                                  {entry.OriginalDocNumber}
                                </div>
                                <div className="text-nowrap">{issuedOn}</div>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                {entry.ContractorId !== "" && (
                                  <Link
                                    to={`/contractor/${entry.ContractorId}`}
                                    className="btn text-nowrap btn-sm btn-outline-info"
                                  >
                                    {entry.ContractorName}
                                  </Link>
                                )}
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="text-nowrap">
                                  {entry.WarehouseFullName}
                                </div>
                                <div className="text-nowrap">
                                  {entry.RelatedDoc !== "" && (
                                    <Link
                                      to={`/pz/${entry.ToWarehouseOperationId}`}
                                      className="btn text-nowrap btn-sm btn-outline-danger"
                                    >
                                      PZ {entry.ToWarehouseOperationId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="text-nowrap">
                                  {`${entry.TotalBrutto} zł`}
                                </div>
                                <div className="text-nowrap">
                                  {`${entry.TotalVAT} zł`}
                                </div>
                                <div className="text-nowrap">
                                  {`${entry.TotalNetto} zł`}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="text-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={entry.IsPaid}
                                    readOnly
                                  />
                                </div>
                                <div className="text-nowrap d-flex justify-content-center">
                                  {paymentDate}
                                </div>
                              </div>
                            </td>

                            <td>
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <Link
                                  to={`/fz/${entry.WarehouseOperationId}`}
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  Edytuj
                                </Link>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              ) : (
                <NoResults />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <div>{getUI()}</div>;
};

export default FZS;